import React from "react";

const NoResults = ({ styles }) => {
  return <div className={`${styles.noResult}`}>No Data to Display</div>;
};

export default NoResults;
